<template>
  <v-tooltip content-class="tooltip-popup" :max-width="width" top v-if="hasPermission('has_inline_help')">
    <template v-slot:activator="{ on }">
      <v-icon :medium="medium" :color="color" class="pl-2" v-on="on">{{ icon }}</v-icon>
    </template>
    <slot name="message"></slot>
  </v-tooltip>
</template>

<script>
import AuthMixin from '@/mixins/auth'

export default {
  mixins: [AuthMixin],
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: String,
      default: 'fa-lightbulb-o'
    },
    medium: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '300px'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/help/Lightbulb.vue